import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { PILLARS } from "../data/services";

export const Footer = () => (
    <footer className="border-t border-white/10" style={{ background: "#080D1A" }} data-testid="site-footer">
        <div className="container-x grid gap-12 py-16 md:grid-cols-2 lg:grid-cols-4">
            <div>
                <span
                    className="relative inline-block"
                    style={{ height: "64px", aspectRatio: "1370 / 919" }}
                    role="img"
                    aria-label="Innovated Global IT Solutions logo — Ideas. Innovation. Impact."
                >
                    <span aria-hidden="true" className="absolute top-0" style={{ left: "25.11%", width: "49.78%" }}>
                        <img src="/assets/flower-mark.png" alt="" className="header-flower-spin w-full h-auto" />
                    </span>
                    <img src="/assets/logo-name.png" alt="" aria-hidden="true" className="logo-ondark absolute left-0 w-full" style={{ top: "69%" }} />
                    <img src="/assets/logo-name-dark.png" alt="" aria-hidden="true" className="logo-onlight absolute left-0 w-full" style={{ top: "69%" }} />
                    <img src="/assets/logo-tagline.png" alt="" aria-hidden="true" className="logo-ondark absolute left-0 w-full" style={{ top: "94.3%" }} />
                    <img src="/assets/logo-tagline-dark.png" alt="" aria-hidden="true" className="logo-onlight absolute left-0 w-full" style={{ top: "94.3%" }} />
                </span>
                <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
                    Technology that moves your business forward.
                </p>
            </div>

            <nav aria-label="Services">
                <h3 className="eyebrow text-slate-500">Services</h3>
                <ul className="mt-5 space-y-3">
                    {PILLARS.map((p) => (
                        <li key={p.slug}>
                            <Link
                                to={`/services/${p.slug}`}
                                data-testid={`footer-service-${p.slug}`}
                                className="text-sm text-slate-400 transition-colors duration-200 hover:text-white"
                            >
                                {p.name}
                            </Link>
                        </li>
                    ))}
                </ul>
            </nav>

            <nav aria-label="Company">
                <h3 className="eyebrow text-slate-500">Company</h3>
                <ul className="mt-5 space-y-3">
                    <li><Link to="/" data-testid="footer-home-link" className="text-sm text-slate-400 transition-colors duration-200 hover:text-white">Home</Link></li>
                    <li><Link to="/about" data-testid="footer-about-link" className="text-sm text-slate-400 transition-colors duration-200 hover:text-white">About</Link></li>
                    <li><Link to="/industries" data-testid="footer-industries-link" className="text-sm text-slate-400 transition-colors duration-200 hover:text-white">Industries</Link></li>
                    <li><Link to="/contact" data-testid="footer-contact-link" className="text-sm text-slate-400 transition-colors duration-200 hover:text-white">Contact</Link></li>
                </ul>
            </nav>

            <div>
                <h3 className="eyebrow text-slate-500">Reach Us</h3>
                <ul className="mt-5 space-y-4 text-sm text-slate-400">
                    <li className="flex gap-3">
                        <MapPin size={16} className="mt-0.5 shrink-0 text-cyan-300" aria-hidden="true" />
                        <span>Neena Thapa Road, Kunraghat,<br />Gorakhpur, Uttar Pradesh 273008, India</span>
                    </li>
                    <li className="flex gap-3">
                        <Phone size={16} className="mt-0.5 shrink-0 text-cyan-300" aria-hidden="true" />
                        <span className="flex flex-col gap-1">
                            <a href="tel:+918971740472" data-testid="footer-phone-link" className="transition-colors duration-200 hover:text-white">
                                +91 89717 40472
                            </a>
                            <a href="tel:+918303355977" data-testid="footer-phone-link-2" className="transition-colors duration-200 hover:text-white">
                                +91 83033 55977
                            </a>
                        </span>
                    </li>
                    <li className="flex gap-3">
                        <Mail size={16} className="mt-0.5 shrink-0 text-cyan-300" aria-hidden="true" />
                        <span className="flex flex-col gap-1">
                            <a href="mailto:hello@innovatedglobal.in" data-testid="footer-email-link" className="transition-colors duration-200 hover:text-white">
                                hello@innovatedglobal.in
                            </a>
                            <a href="mailto:support@innovatedglobal.in" data-testid="footer-email-support-link" className="transition-colors duration-200 hover:text-white">
                                support@innovatedglobal.in
                            </a>
                        </span>
                    </li>
                </ul>
            </div>
        </div>

        <div className="border-t border-white/5">
            <div className="container-x flex flex-col items-center justify-between gap-3 py-6 sm:flex-row">
                <p className="text-xs text-slate-500">
                    © {new Date().getFullYear()} Innovated Global IT Solutions Private Limited. All rights reserved.
                </p>
                <p className="tagline-gradient text-xs font-semibold tracking-widest" style={{ fontFamily: "Fira Code, monospace" }} data-testid="footer-tagline">
                    IDEAS · INNOVATION · IMPACT
                </p>
            </div>
        </div>
    </footer>
);
